import {clsx} from 'clsx'
import type {ComponentPropsWithoutRef} from 'react'

import styles from './base-cell.module.css'

type BaseCellProps = ComponentPropsWithoutRef<'div'> & {
  editing?: boolean
  disallowSelection?: boolean
  ref?: React.Ref<HTMLDivElement>
}

export const BaseCell = ({ref, ...props}: BaseCellProps) => {
  const {editing, disallowSelection, className, ...other} = props

  return (
    <div
      ref={ref}
      className={clsx(
        className,
        styles.Box,
        editing && styles.editingCell,
        disallowSelection && styles.disallowSelection,
      )}
      {...other}
    />
  )
}

BaseCell.displayName = 'BaseCell'
